module.exports = __webpack_public_path__ + "images/stickers/check.90e26477b42f93cf816e.png";